(function () {
  var root = document.getElementById('petmug');
  if (!root) return;
  var design = root.dataset.design === 'B' ? 'B' : 'A';
  var preview = root.querySelector('.petmug__preview canvas');
  var pctx = preview.getContext('2d');
  var nameIn = root.querySelector('#petmug-name');
  var nameCount = root.querySelector('[data-for="petmug-name"]');
  var pick = root.querySelector('#petmug-pick');
  var photoBox = root.querySelector('.petmug__photo');
  var fileIn = root.querySelector('#petmug-file');
  var cropBox = root.querySelector('.petmug__crop');
  var crop = cropBox.querySelector('canvas');
  var cctx = crop.getContext('2d');
  var zoomIn = root.querySelector('.petmug__zoom');
  var warn = root.querySelector('.petmug__warn');
  var err = root.querySelector('.petmug__error');
  var hidden = {
    name: root.querySelector('[data-petmug="name"]'),
    picture: root.querySelector('[data-petmug="picture"]'),
    art: root.querySelector('[data-petmug="art"]'),
    photo: root.querySelector('[data-petmug="photo"]')
  };
  var OUT = 1000;           // the square photo we upload and print
  var icons = {}, sample = null, ready = false;
  var src = null, view = { x: 0, y: 0, zoom: 1 };
  var square = document.createElement('canvas');
  square.width = square.height = OUT;

  pick.value = design === 'A' ? 'mixed-breed-dog' : 'photo';

  // Attach the order fields to the product form (form.id can be shadowed by the input named "id").
  var addBtn = document.querySelector('product-form button[name="add"], form[action*="/cart/add"] button[name="add"]');
  var form = addBtn ? (addBtn.form || addBtn.closest('form')) : null;
  if (form) {
    var formId = form.getAttribute('id');
    if (!formId) { formId = 'petmug-product-form'; form.setAttribute('id', formId); }
    Object.keys(hidden).forEach(function (k) { hidden[k].setAttribute('form', formId); });
    hidden.name.disabled = hidden.picture.disabled = hidden.art.disabled = false;
  }

  function currentSize() {
    var el = document.querySelector('input[name^="Size"]:checked, select[name="options[Size]"]');
    return el && /^15/.test(el.value) ? 15 : 11;
  }
  function isPhoto() { return pick.value === 'photo'; }
  function iconUrl(slug) { return root.dataset.iconBase + 'pet-' + slug + '.png' + root.dataset.iconQuery; }

  function showError(msg, focusEl) {
    err.textContent = msg;
    err.hidden = false;
    if (focusEl) {
      focusEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      focusEl.focus({ preventScroll: true });
    }
  }

  function art() {
    if (isPhoto()) return { kind: 'photo', img: src ? square : sample };
    return { kind: 'icon', img: icons[pick.value] || null };
  }

  function draw() {
    if (!ready || !window.drawPetMug) return;
    var g = window.petMugSizes[currentSize()], s = 0.5;
    if (preview.width !== g.W * s || preview.height !== g.H * s) { preview.width = g.W * s; preview.height = g.H * s; }
    window.drawPetMug(pctx, { design: design, name: nameIn.value || nameIn.placeholder, background: '#fff' }, art(), s, currentSize());
  }

  function sync() {
    var name = nameIn.value.replace(/\s+/g, ' ').trim();
    hidden.name.value = name;
    nameCount.textContent = nameIn.value.length + '/14';
    var photo = isPhoto();
    photoBox.hidden = !photo;
    hidden.art.value = photo ? 'photo' : pick.value;
    hidden.picture.value = photo ? 'My photo' : (pick.selectedOptions[0] && pick.selectedOptions[0].dataset.label) || pick.value;
    hidden.photo.disabled = !(photo && src);
    if (name) root.classList.remove('petmug--invalid');
    if (!err.hidden && name && (!photo || src)) err.hidden = true;
    if (!photo && !icons[pick.value]) loadImg(iconUrl(pick.value)).then(function (i) { icons[pick.value] = i; draw(); });
    draw();
  }

  // ---- the photo: load, frame, crop to a square ----
  function clampView() {
    var w = src.width, h = src.height, base = Math.min(w, h);
    var half = base / view.zoom / 2;
    view.x = Math.min(Math.max(view.x, half), w - half);
    view.y = Math.min(Math.max(view.y, half), h - half);
    return half;
  }
  function renderCrop() {
    if (!src) return;
    var half = clampView(), sx = view.x - half, sy = view.y - half, side = half * 2;
    var sctx = square.getContext('2d');
    sctx.drawImage(src, sx, sy, side, side, 0, 0, OUT, OUT);
    var C = crop.width;
    cctx.clearRect(0, 0, C, C);
    cctx.drawImage(src, sx, sy, side, side, 0, 0, C, C);
    // Dim what falls outside the circle, so they see what prints.
    cctx.save();
    cctx.fillStyle = 'rgba(255,255,255,0.65)';
    cctx.beginPath();
    cctx.rect(0, 0, C, C);
    cctx.arc(C / 2, C / 2, C / 2 - 4, 0, Math.PI * 2, true);
    cctx.fill('evenodd');
    cctx.beginPath();
    cctx.arc(C / 2, C / 2, C / 2 - 4, 0, Math.PI * 2);
    cctx.lineWidth = 4;
    cctx.strokeStyle = '#111';
    cctx.stroke();
    cctx.restore();
    warn.hidden = side >= 600;
    draw();
  }

  function loadImg(url) {
    return new Promise(function (res) {
      var i = new Image();
      i.onload = function () { res(i); };
      i.onerror = function () { res(null); };
      i.src = url;
    });
  }

  fileIn.addEventListener('change', function () {
    var f = fileIn.files && fileIn.files[0];
    if (!f) return;
    var url = URL.createObjectURL(f);
    loadImg(url).then(function (img) {
      URL.revokeObjectURL(url);
      if (!img || !img.naturalWidth) {
        showError('That photo didn’t open in your browser. Please try a JPG or PNG. On an iPhone, a screenshot of the photo works.');
        return;
      }
      // Keep a working copy no bigger than 2400px: plenty for print, easy on phones.
      var k = Math.min(1, 2400 / Math.max(img.naturalWidth, img.naturalHeight));
      var c = document.createElement('canvas');
      c.width = Math.round(img.naturalWidth * k);
      c.height = Math.round(img.naturalHeight * k);
      c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
      src = c;
      // Start a little above centre: faces usually sit high in a photo.
      view = { x: c.width / 2, y: c.height * 0.45, zoom: 1 };
      zoomIn.value = 1;
      cropBox.hidden = false;
      renderCrop();
      sync();
    });
  });

  zoomIn.addEventListener('input', function () { if (!src) return; view.zoom = Number(zoomIn.value) || 1; renderCrop(); });

  var drag = null;
  crop.addEventListener('pointerdown', function (e) {
    if (!src) return;
    drag = { x: e.clientX, y: e.clientY };
    crop.setPointerCapture(e.pointerId);
    crop.style.cursor = 'grabbing';
  });
  crop.addEventListener('pointermove', function (e) {
    if (!drag || !src) return;
    var per = (Math.min(src.width, src.height) / view.zoom) / crop.getBoundingClientRect().width;
    view.x -= (e.clientX - drag.x) * per;
    view.y -= (e.clientY - drag.y) * per;
    drag = { x: e.clientX, y: e.clientY };
    renderCrop();
  });
  function endDrag() { drag = null; crop.style.cursor = ''; }
  crop.addEventListener('pointerup', endDrag);
  crop.addEventListener('pointercancel', endDrag);

  // Put the framed square, not the original, in the order's Photo property.
  function attachPhoto() {
    var data = square.toDataURL('image/jpeg', 0.9);
    var bin = atob(data.split(',')[1]), bytes = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
    var file = new File([bytes], 'pet-photo.jpg', { type: 'image/jpeg' });
    var dt = new DataTransfer();
    dt.items.add(file);
    hidden.photo.files = dt.files;
    hidden.photo.disabled = false;
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.name && /^(Size|options\[Size\])/.test(t.name)) setTimeout(draw, 0);
  });
  pick.addEventListener('change', sync);
  nameIn.addEventListener('input', sync);

  // A name is required, and a photo when they chose one: say why, right where they are.
  document.addEventListener('submit', function (e) {
    if (!form || e.target !== form) return;
    sync();
    var stop = function () { e.preventDefault(); e.stopImmediatePropagation(); };
    if (!hidden.name.value) {
      stop();
      root.classList.add('petmug--invalid');
      showError('Please add your pet’s name first. It goes in the big letters.', nameIn);
      return;
    }
    if (isPhoto()) {
      if (!src) {
        stop();
        showError('Please choose a photo, or pick a breed drawing from the list instead.', pick);
        return;
      }
      try { attachPhoto(); } catch (x) {
        stop();
        showError('Your browser couldn’t attach the photo. Please try another browser, or pick a breed drawing instead.');
      }
    } else {
      hidden.photo.disabled = true;
    }
  }, true);

  function loadFont(family, url) {
    return new FontFace(family, 'url(' + url + ')').load().then(function (ff) { document.fonts.add(ff); });
  }
  function start() {
    if (!window.drawPetMug) return setTimeout(start, 50);
    Promise.all([
      loadFont('BIW Pet Name', root.dataset.nameFont),
      loadFont('BIW Pet Type', root.dataset.typeFont),
      loadFont('BIW Pet Type Bold', root.dataset.typeBold),
      loadImg(root.dataset.sample)
    ]).then(function (r) { sample = r[3]; }).catch(function () {}).then(function () { ready = true; sync(); });
  }
  sync();
  start();
})();
